import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Avatar from "../assets/Avatar6.png";
import { profilesEndpoint   } from "../constants";
import axios from "axios";


function Notfication() {
  const [notifications, setNotifications] = useState([]);
  const token =  localStorage.getItem(("token"))

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await axios.get(profilesEndpoint+"list_notifications/", {
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json',
        }
      });
        const data =  response.data
        setNotifications(data.results);
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };

    fetchNotifications();
  }, []);

  return (
    <div className="w-full flex flex-col gap-8">
      <div className="">
        <h1 className="text-2xl font-semibold text-gray-900">Notifications</h1>
        <p className="mt-1 text-sm text-gray-600">
          Here you can get a bird’s eye view of revenue, expenses and cash flow
        </p>
      </div>

      {/*  */}

      <div className="w-full flex flex-col my-5">
        {notifications.map((notification) => (
          <div className="flex gap-5" key={notification.id}>
            <img src={Avatar} alt="" className="w-14 h-14" />
            <div className="border-b border-gray-200 w-full flex items-center justify-between py-4">
              <div className="flex flex-col gap-4">
                <Link to={`/notifications/${notification.id}`}>
                  <p
                    className={`text-gray-400 text-sm ${
                      notification.respond === true ? "pb-10" : ""
                    }`}
                  >
                    {notification.verb}
                  </p>
                </Link>
                {notification.respond === false && (
                  <div className="flex gap-5 items-center">
                    <button className="border border-gray-300 px-3 py-2 rounded-lg text-gray-700 cursor-pointer text-xs font-semibold">
                      Ignore
                    </button>
                    <button className="bg-[#19BFB7] text-xs px-3 py-2 rounded-lg text-white cursor-pointer font-semibold">
                      Review
                    </button>
                  </div>
                )}
              </div>
              <div className="flex flex-col gap-1 items-center">
                <p className="text-xs text-gray-700 font-semibold">
                  {notification.timestamp}
                </p>

                <button className="text-gray-700 font-sm font-semibold rotate-90 cursor-pointer">
                  &#8942;
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Notfication;
